import { createReducer } from 'redux-act';
import { resource, setLastAskedCountry } from './actions';
export const initialState = {
  lastAskedCountry: undefined,
  countries: []
};
export const fetchListSuccessHandler = (state, {
  response
}) => ({
  ...state,
  countries: response.data
});
export const setLastAskedCountryHandler = (state, alpha2) => ({
  ...state,
  lastAskedCountry: alpha2
});
export const fetchOneSuccessHandler = (state, {
  response,
  label
}) => {
  const {
    data
  } = response;
  return {
    ...state,
    [label]: {
      ...data
    }
  };
};
const reducer = createReducer({
  [setLastAskedCountry.getType()]: setLastAskedCountryHandler,
  [resource.fetch.success.getType()]: fetchListSuccessHandler,
  [resource.fetchOne.success.getType()]: fetchOneSuccessHandler
}, initialState);
export default reducer;